export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  ACCOUNT: { CREATE: "/accounts/e", LIST: "/accounts", EDIT: "/accounts/:id/e", VIEW: "/accounts/:id" },
  CONTACT: { CREATE: "/contacts/e", LIST: "/contacts", EDIT: "/contacts/:id/e", VIEW: "/contacts/:id" },
  LEAD: { CREATE: "/leads/e", LIST: "/leads", EDIT: "/leads/:id/e", VIEW: "/leads/:id" },
  USER: { CREATE: "/users/e", LIST: "/users", EDIT: "/users/:id/e", VIEW: "/users/:id" },
  USER_TRACKING:"/user_tracking",
  OFFER:{ CREATE: "/offers/e", LIST: "/offers", EDIT: "/offers/:id/e", VIEW: "/offers/:id" },
  ORDER:{ CREATE: "/orders/e", LIST: "/orders", EDIT: "/orders/:id/e", VIEW: "/orders/:id" },
  HANDOVER:{ CREATE: "/handovers/e", LIST: "/handovers", EDIT: "/handovers/:id/e", VIEW: "/handovers/:id" },
  ORDER_AMC:{ CREATE: "/order_amcs/e", LIST: "/order_amcs", EDIT: "/order_amcs/:id/e", VIEW: "/order_amcs/:id" },
  PRODUCT:{ CREATE: "/products/e", LIST: "/products", EDIT: "/products/:id/e", VIEW: "/products/:id" },
  REPORT: {LIST: "/reports", VIEW : "/reports/:id"},
  WARRANTY: { CREATE: "/warranties/e", LIST: "/warranties", EDIT: "/warranties/:id/e", VIEW: "/warranties/:id" },
  DASHBOARD: "/dashboards",
  BACKUP: "/backups",
  PROFILE:"/profile",
  ENQUIRY_FORM:"/enquiry_form",
  SERVICE_FORM:"/service_form",
  SETTINGS:"/settings",
  PRICING_MASTER: { LIST: "/pricing-master" },
  MARGIN_MASTER: { LIST: "/margin-master" },
}